import styled from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { RED_COLOR_TAB_ACTIVE } from '~/src/features/center/constants/ordinary';

export const Icon = styled.svg`
    width: 38px;
    height: 42px;
    transition: fill .1s linear;
    margin-top: 15px;
`;

export const IconBlock = styled.div`
    display: block;
    width: 130px;
    height: 122px;
    text-align: center;

    &:hover {
        fill: ${RED_COLOR_TAB_ACTIVE};
        cursor: pointer;
        background: ${COLORS.BgMain};
        box-shadow: 0 4px 16px rgba(0, 0, 0, .1);
        border-radius: ${BorderRadius.InnerBlockRadius};
    }
`;

export const Title = styled.div`
    width: 100px;
    ${FONTS.XS};
    margin: auto;
`;
